import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { applySettings, loadSettings } from './game/settings.ts'

// Stamp the player's text-scale and motion choices onto the document root
// before the first paint, so the game opens at their settings rather than
// snapping to them a frame later.
applySettings(loadSettings())

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
